import { createSlice } from '@reduxjs/toolkit';




const initialState = {
  HR:[]
};

export const hrSlice = createSlice({
  name: 'HR',
  initialState,
  reducers: {
    setHR: (state, { payload }) => {
     
      state.HR = [...payload];
    },
    
   
    clearHRState: (state) => {
      state=initialState
    }
  }
});

export const { setHR, clearHRState } = hrSlice.actions;

export const HRData = (state) => state.HR;
export const getCustomerById = (id) => (state) => {
  return state.HR.HR.find((el) => el.id?.toString() === id?.toString());
};
export const customerDataForAutoComplete = (state) => {
  return state.HR.HR.map((el) => {
    return {
      ...el,
      label:  el.name_english + " " + el.name_urdu,
    };
  });
};



export default hrSlice.reducer;
